/** When `'true'`, hides the official plugin banner sitewide. */
export const OFFICIAL_PLUGIN_BANNER_DISMISSED_KEY = 'officialPluginBannerDismissed';

export const OFFICIAL_PLUGIN_BANNER_DISMISSED_EVENT = 'officialPluginBannerDismissed';

export function isOfficialPluginBannerDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(OFFICIAL_PLUGIN_BANNER_DISMISSED_KEY) === 'true';
}

/** Sets the shared dismiss flag and notifies listeners in the same tab. */
export function dismissOfficialPluginBanner() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(OFFICIAL_PLUGIN_BANNER_DISMISSED_KEY, 'true');
  window.dispatchEvent(new CustomEvent(OFFICIAL_PLUGIN_BANNER_DISMISSED_EVENT));
}
